var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipseArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ep:arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.72488 10.9751L13.6911 17.9445C13.8074 18.0608 13.9618 18.1257 14.1224 18.1257C14.283 18.1257 14.4374 18.0608 14.5536 17.9445L14.5611 17.9366C14.6177 17.8802 14.6627 17.8123 14.6935 17.7371C14.7242 17.6618 14.7401 17.5808 14.7401 17.4989C14.7401 17.417 14.7242 17.336 14.6935 17.2607C14.6627 17.1855 14.6177 17.1176 14.5611 17.0612L8.00113 10.4987L14.5611 3.93879C14.6177 3.88239 14.6627 3.8145 14.6935 3.73925C14.7242 3.664 14.7401 3.58297 14.7401 3.50108C14.7401 3.41919 14.7242 3.33815 14.6935 3.2629C14.6627 3.18765 14.6177 3.11976 14.5611 3.06336L14.5536 3.05548C14.4374 2.93914 14.283 2.87423 14.1224 2.87423C13.9618 2.87423 13.8074 2.93914 13.6911 3.05548L6.72488 10.0249C6.66362 10.0861 6.61484 10.1599 6.58152 10.2415C6.54819 10.3232 6.53101 10.4111 6.53101 10.5C6.53101 10.5888 6.54819 10.6768 6.58152 10.7584C6.61484 10.8401 6.66362 10.9138 6.72488 10.9751Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseArrowUp);
export default __webpack_public_path__ + "static/media/ellipse-arrow-up.f94ecaec00f94abf1017e77d634411e1.svg";
export { ForwardRef as ReactComponent };